import {
  Box,
  BoxProps,
  Icon,
  IconProps,
  Typography,
} from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { CommonProps, IconListProps } from './types'

export const IconListContainer: FC<CommonProps & BoxProps> = ({
  children,
  ...props
}) => {
  return (
    <Box
      as="ul"
      $display="flex"
      $direction="column"
      $gap={3}
      $p={0}
      $m={0}
      {...props}
    >
      {children}
    </Box>
  )
}

export const IconListItem: FC<CommonProps> = ({ children }) => {
  return (
    <Box as="li" $display="flex" $gap={4} $fullWidth>
      {children}
    </Box>
  )
}

export const IconListItemIcon: FC<IconProps> = props => {
  return (
    <Box $flexShrink={0}>
      <Icon {...props} size={6} />
    </Box>
  )
}

export const IconListItemContent: FC<CommonProps> = ({ children }) => {
  return (
    <Box $display="flex" $direction="column" $align="initial" $gap={1}>
      {children}
    </Box>
  )
}

export const IconListItemHeader: FC<CommonProps> = ({ children }) => {
  return <Typography $bold>{children}</Typography>
}

export const IconListItemDescription: FC<CommonProps> = ({ children }) => {
  return (
    <Typography $color="textMuted" $size="xs">
      {children}
    </Typography>
  )
}

export const IconList: FC<IconListProps> = ({ items }) => {
  return (
    <IconListContainer>
      {items.map((item, index) => (
        <IconListItem key={index}>
          <IconListItemIcon Icon={item.icon} />
          <IconListItemContent>
            <IconListItemHeader>{item.header}</IconListItemHeader>
            <IconListItemDescription>
              {item.description}
            </IconListItemDescription>
          </IconListItemContent>
        </IconListItem>
      ))}
    </IconListContainer>
  )
}
